import usePay from 'hooks/business/pay/usePay';
import { useMemo, useState } from 'react';

// 企业版支持 CNY&USD
const enterpriseCurrencies: General.Currency[] = ['CNY', 'USD'];

const usePayPackage = () => {
  const { availableCurrencies, ...otherProps } = usePay();

  // 是否选择企业版套餐
  const [isEnterprise, setIsEnterprise] = useState(false);

  // 币种选项
  const currenciesOptions = useMemo(() => {
    return isEnterprise ? enterpriseCurrencies : availableCurrencies;
  }, [isEnterprise, availableCurrencies]);

  return {
    currenciesOptions,
    isEnterprise,
    setIsEnterprise,
    availableCurrencies,
    ...otherProps,
  };
};

export default usePayPackage;
